import config from '../../config.js';
import callApi from '../../util/apiCaller.js';
import { sequence } from '../../util/promises.js';

import { setHasUpdate, setMounted } from './AppActions.js';
import { getOrdersByUserRequest } from '../Order/OrderActions.js';
import { getUserGroupRequest } from '../User/UserGroupActions.js';
import { isLoggedInRequest } from '../User/UserActions.js';
import { getAddressesRequest } from '../Address/AddressActions.js';
import { addError } from '../Error/ErrorActions.js';
import { getProductsRequest } from '../Product/ProductActions.js';

export function initApp(isSSR = false, initActions = []) {
    // console.log('INIT APP');
    return dispatch => {
        return (isSSR ? Promise.resolve(null) : dispatch(isLoggedInRequest()).catch(err => null)).then(user => {
            if(user) {
                initActions.push(getOrdersByUserRequest, getAddressesRequest);
                switch(user.role) {
                    case 'admin':
                        initActions.push(() => getProductsRequest(true));
                        break;

                    case 'customer':
                    default:
                        // initActions = initActions.concat([]);
                        break;
                }
            // } else {
            } else {
                // isSSR && initActions.push(getUserGroupRequest);
            }
            return sequence(initActions, dispatch).then(results => {
                dispatch(setMounted());
                if(typeof window !== 'undefined' && window.dataLayer) {
                    window.dataLayer.push({ event: 'optimize.callback' });
                }
            }).catch(err => {
                console.error('AppInitializationError', err);
            });
        });
    };
}

// Only flags the store: the reload itself is deferred to the next URL change (cf. reloadForUpdate,
// called from the Header location effect). Reloading on the spot would cut the visitor off mid-page,
// and the socket event `app/update/web` can land at any moment, including during checkout.
export function checkVersionRequest() {
    return dispatch => callApi('app/web/version').then(res => {
        const hasUpdate = Boolean(res.version) && res.version !== config.version;

        if(hasUpdate) {
            dispatch(setHasUpdate(true));

            if(process.env.NODE_ENV === 'development') {
                console.log('App::: Need refresh', res.version, config.version);
            }
        }

        return hasUpdate;
    }).catch(error => {
        dispatch(addError(error));
        return false;
    });
}

// Applies a pending update. The browser reloads the URL it is currently on, which is the one the
// visitor just navigated to, so they land on the page they asked for, served by the new build.
export function reloadForUpdate() {
    if(typeof window === 'undefined' || process.env.NODE_ENV === 'development') {
        return false;
    }

    window.location.reload();

    return true;
}

export function clearCacheRequest() {
    return dispatch => callApi('app/cache/reset').then(res => {
        return res && res.ok;
    }).catch(error => {
        dispatch(addError(error));
        return false;
    });
}

export function launchCronRequest(key, param) {
    return dispatch => {
        return callApi('cron/launch', 'post', { cron: { key, param } }).then(res => {
            return res.ok;
        }).catch(error => {
            dispatch(addError(error));
            return null;
        });
    };
}

export function backupAppRequest() {
    return dispatch => callApi('app/backup').then(res => {
        return res && res.ok;
    }).catch(error => {
        dispatch(addError(error));
        return false;
    });
}
